import { EXIT_SVG } from './widgetDomShared.js';

export function setupInitModal(options: {
  modal: HTMLElement;
  onClose(): void;
  onSubmit(name: string): void;
}): void {
  const { modal, onClose, onSubmit } = options;

  modal.querySelector<HTMLButtonElement>('.bs-name-close')?.addEventListener('click', onClose);

  const nameInput = modal.querySelector<HTMLInputElement>('.bs-name-input');
  const submitBtn = modal.querySelector<HTMLButtonElement>('.bs-name-submit');

  const syncSubmitState = () => {
    if (!submitBtn || !nameInput) return;
    submitBtn.disabled = !nameInput.value.trim();
  };

  nameInput?.addEventListener('input', syncSubmitState);
  modal.querySelector<HTMLFormElement>('.bs-name-form')?.addEventListener('submit', (event) => {
    event.preventDefault();
    const name = nameInput?.value.trim() ?? '';
    if (!name) return;
    onSubmit(name);
  });

  syncSubmitState();
  nameInput?.focus();
}

export function renderInitModalHtml() {
  return `
    <div class="bs-name-inner">
      <button class="bs-name-close" type="button" aria-label="Close">${EXIT_SVG}</button>
      <h4 class="bs-name-title">What should we call you?</h4>
      <p class="bs-name-subtitle">This name shows up next to your comments - no account or email required.</p>
      <form class="bs-name-form">
        <input class="bs-name-input" type="text" placeholder="Your name" autocomplete="name" maxlength="120" />
        <button class="bs-name-submit" type="submit" disabled>Start leaving feedback</button>
      </form>
    </div>`;
}
